import { themeConfig } from "@gap/shared/theme"
import { DirectiveEditorProps, readOnly$, useCellValue, useMdastNodeUpdater } from "@mdxeditor/editor"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import TextField from "@mui/material/TextField"
import DialogActions from "@mui/material/DialogActions"
import Box from "@mui/material/Box"
import Link from "@mui/material/Link"
import Button from "@mui/material/Button"
import { observer } from "mobx-react-lite"
import useStore from "reusable/mobx-store-utils"
import InsertDriveFileOutlined from "@mui/icons-material/InsertDriveFileOutlined"
import GapFileComponentStore from "./GapFileComponentStore"
import { useMarkdownStore } from "reusable/markdown/MarkdownStore"
import useInitialMount from "reusable/hooks/useInitialMount"

export default observer(function GapFileComponent({ mdastNode }: DirectiveEditorProps) {
   const isReadOnly = useCellValue(readOnly$)
   const updateMdastNode = useMdastNodeUpdater()
   const markdownStore = useMarkdownStore()

   const gapFilePluginStore = useStore(sp => new GapFileComponentStore(sp), {
      updateMdastNode,
      isReadOnly,
      markdownStore,
      attributes: mdastNode.attributes as Record<string, string> | undefined
   })

   useInitialMount(() => {
      gapFilePluginStore.getDownloadUrl()
   })

   return <>
      <Box
         onClick={!isReadOnly ? gapFilePluginStore.handleEditClick : undefined}
         sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            backgroundColor: '#f8fafc',
            border: `1px solid ${themeConfig.primary['200']}`,
            borderRadius: 1,
            px: 1.5,
            py: 0.75,
            my: 0.5,
            cursor: !isReadOnly ? 'pointer' : 'default',
            '&:hover': !isReadOnly ? {
               backgroundColor: '#f1f5f9',
            } : {},
         }}
      >
         <InsertDriveFileOutlined sx={{ fontSize: 18, color: themeConfig.primary['600'] }} />
         <Link
            href={isReadOnly && gapFilePluginStore.downloadUrl ? gapFilePluginStore.downloadUrl : undefined}
            target="_blank"
            rel="noopener noreferrer"
            onClick={gapFilePluginStore.handleLinkClick}
            sx={{
               color: themeConfig.primary['700'],
               textDecoration: 'underline',
               fontSize: '0.95rem',
               cursor: 'pointer',
               '&:hover': {
                  color: themeConfig.primary['900'],
               },
            }}
         >
            {gapFilePluginStore.fileName}
         </Link>
      </Box>

      <Dialog open={gapFilePluginStore.editing} onClose={gapFilePluginStore.handleCancel} maxWidth="sm" fullWidth>
         <DialogTitle>Edit File Name</DialogTitle>
         <DialogContent>
            <TextField
               fullWidth
               label="File name"
               value={gapFilePluginStore.editedName}
               onChange={gapFilePluginStore.onTextfieldUpdate}
               autoFocus
               sx={{ mt: 1 }}
            />
         </DialogContent>
         <DialogActions>
            <Button onClick={gapFilePluginStore.handleCancel}>Cancel</Button>
            <Button onClick={gapFilePluginStore.handleSave} variant="contained">
               Save
            </Button>
         </DialogActions>
      </Dialog>
   </>
})